module.exports = __webpack_public_path__ + "img/msu3-char-5.1ce8a138.png";